// CruisesDialog.js
import {
    defineComponent,
    ref,
    computed,
    watch,
    inject,
    nextTick,
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;
export default defineComponent({
    name: "CruisesDialog",
    props: {},
    emits: [],
    setup(props, { emit }) {
        const cruiseDialogPopup = inject("cruiseDialogPopup", ref(false));
        const nowCruiseKey = inject("nowCruiseKey");
        const CruisePriceData = inject("CruisePriceData", ref({}));
        const cruiseName = inject("cruiseName");
        const web = inject("web");
        const modalContentRef = ref(null);
        const isVisible = ref(false);
        const isActive = ref(false);

        const handleOverlayClick = (e) => {
            // 如果點擊的是 modal 外部，就關閉
            if (modalContentRef.value && !modalContentRef.value.contains(e.target)) {
                cruiseDialogPopup.value = false;
            }
        };

        watch(
            () => cruiseDialogPopup.value,
            async (newVal) => {
                if (newVal) {
                    isVisible.value = true;
                    await nextTick();
                    setTimeout(() => {
                        isActive.value = true;
                    }, 2);
                } else {
                    isActive.value = false;
                    setTimeout(() => {
                        isVisible.value = false;
                    }, 400);
                }
            },
            { immediate: true }
        );
        return {
            cruiseDialogPopup, isVisible, isActive, CruisePriceData, web, cruiseName, modalContentRef,
            handleOverlayClick };
    },
    template: html`
        <div
            class="cruises_dialog Com_PopupBg"
            :style="{ display: isVisible ? 'block' : 'none' }"
            :class="{ active: isActive }"
            @click="handleOverlayClick"
        >
            <div class="modal-content Com_halfPopup" ref="modalContentRef">
                <div class="modal_header">
                    <h1>艙房售價表</h1>
                    <button
                        class="close_btn"
                        @click="cruiseDialogPopup = false"
                    >
                        <svg
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2.8 28L0 25.2L11.2 14L0 2.8L2.8 0L14 11.2L25.2 0L28 2.8L16.8 14L28 25.2L25.2 28L14 16.8L2.8 28Z"
                                fill="#8A8A8A"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div class="modal_body scrollbarWidth">
                    <div class="title">艙房售價表</div>
                    <div class="">
                        <h2>
                            {{cruiseName}}
                        </h2>
                    </div>
                    <div
                        class="priceTable_crusies_b2c"
                        style="display: block"
                        v-if="CruisePriceData.cruiseTp1?.length > 0 && (web=='b2c' || web=='bbc')"
                    >
                        <div class="container">
                            <ul class="table">
                                <li class="table-row title_header">
                                    <div class="table-cell header_room_title">
                                        艙房售價
                                        <span>(每人價格)</span>
                                    </div>
                                    <div class="table-cell price">兩人一室</div>
                                    <div class="table-cell price">第三人</div>
                                    <div class="table-cell price">第四人</div>
                                </li>
                                <li
                                    class="table-row item"
                                    v-for="room in CruisePriceData.cruiseTp1"
                                >
                                    <div class="table-cell room_title">
                                        <div class="room_name">
                                            {{room.roomName}}
                                            <span>({{room.size}})</span>
                                        </div>
                                    </div>
                                    <div class="table-cell price">
                                        {{room.currAmStr}}
                                    </div>
                                    <div class="table-cell price">
                                        {{room.firAmStr}}
                                    </div>
                                    <div class="table-cell price">
                                        {{room.secAmStr}}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="priceTable_crusies_b2c"
                        style="display: block"
                        v-if="CruisePriceData.cruiseTp2?.length > 0 && (web=='b2c' || web=='bbc')"
                    >
                        <div class="container">
                            <ul class="table">
                                <li class="table-row title_header">
                                    <div class="table-cell header_room_title">
                                        艙房售價
                                        <span>(每人價格)</span>
                                    </div>
                                    <div class="table-cell price">四人一室</div>
                                    <div class="table-cell price">五人一室</div>
                                    <div class="table-cell price">六人一室</div>
                                </li>
                                <li
                                    class="table-row item"
                                    v-for="room in CruisePriceData.cruiseTp1"
                                >
                                    <div class="table-cell room_title">
                                        <div class="room_name">
                                            {{room.roomName}}
                                            <span>({{room.size}})</span>
                                        </div>
                                    </div>
                                    <div class="table-cell price">
                                        {{room.currAmStr}}
                                    </div>
                                    <div class="table-cell price">
                                        {{room.firAmStr}}
                                    </div>
                                    <div class="table-cell price">
                                        {{room.secAmStr}}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="priceTable_crusies_b2b"
                        style="display: block"
                        v-if="CruisePriceData.cruiseTp1?.length > 0 && web=='b2b'"
                    >
                        <div class="container">
                            <ul class="table">
                                <li class="table-row">
                                    <div class="table-cell tabel-cell-title">
                                        艙房售價
                                        <span>(每人價格)</span>
                                    </div>
                                    <ul class="table-cell">
                                        <li class="table-cell-list">
                                            <div class="">兩人一室</div>
                                            <ul>
                                                <li>同業</li>
                                                <li>直客</li>
                                            </ul>
                                        </li>
                                        <li class="table-cell-list">
                                            <div class="">第三人</div>
                                            <ul>
                                                <li>同業</li>
                                                <li>直客</li>
                                            </ul>
                                        </li>
                                        <li class="table-cell-list">
                                            <div class="">第四人</div>
                                            <ul>
                                                <li>同業</li>
                                                <li>直客</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li
                                    class="content-table-row"
                                    v-for="room in CruisePriceData.cruiseTp1"
                                >
                                    <div>
                                        <div class="">
                                            <span class="room_name">
                                                {{room.roomName}}
                                                <span>({{room.size}})</span>
                                            </span>
                                        </div>
                                    </div>
                                    <ul class="m-title">
                                        <li class=""></li>
                                        <li class="">兩人一室</li>
                                        <li class="">第三人</li>
                                        <li class="">第四人</li>
                                    </ul>
                                    <ul class="content-table-cell">
                                        <li
                                            class="content-table-cell-list title"
                                        >
                                            <div class="">同業</div>
                                            <div class="">直客</div>
                                        </li>
                                        <li class="content-table-cell-list">
                                            <div class="">
                                                {{room.currAmStr}}
                                            </div>
                                            <div class="">{{room.zcurrAm}}</div>
                                        </li>
                                        <li class="content-table-cell-list">
                                            <div class="">
                                                {{room.firAmStr}}
                                            </div>
                                            <div class="">
                                                {{room.zfirAmStr}}
                                            </div>
                                        </li>
                                        <li class="content-table-cell-list">
                                            <div class="">
                                                {{room.secAmStr}}
                                            </div>
                                            <div class="">
                                                {{room.zsecAmStr}}
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="priceTable_crusies_b2b"
                        style="display: block"
                        v-if="CruisePriceData.cruiseTp2?.length > 0 && web=='b2b'"
                    >
                        <div class="container">
                            <ul class="table">
                                <li class="table-row">
                                    <div class="table-cell tabel-cell-title">
                                        艙房售價
                                        <span>(每人價格)</span>
                                    </div>
                                    <ul class="table-cell">
                                        <li class="table-cell-list">
                                            <div class="">四人一室</div>
                                            <ul>
                                                <li>同業</li>
                                                <li>直客</li>
                                            </ul>
                                        </li>
                                        <li class="table-cell-list">
                                            <div class="">五人一室</div>
                                            <ul>
                                                <li>同業</li>
                                                <li>直客</li>
                                            </ul>
                                        </li>
                                        <li class="table-cell-list">
                                            <div class="">六人一室</div>
                                            <ul>
                                                <li>同業</li>
                                                <li>直客</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li
                                    class="content-table-row"
                                    v-for="room in CruisePriceData.cruiseTp2"
                                >
                                    <div>
                                        <div class="">
                                            <span class="room_name">
                                                {{room.roomName}}
                                                <span>({{room.size}})</span>
                                            </span>
                                        </div>
                                    </div>
                                    <ul class="m-title">
                                        <li class=""></li>
                                        <li class="">四人一室</li>
                                        <li class="">五人一室</li>
                                        <li class="">六人一室</li>
                                    </ul>
                                    <ul class="content-table-cell">
                                        <li
                                            class="content-table-cell-list title"
                                        >
                                            <div class="">同業</div>
                                            <div class="">直客</div>
                                        </li>
                                        <li class="content-table-cell-list">
                                            <div class="">
                                                {{room.currAmStr}}
                                            </div>
                                            <div class="">{{room.zcurrAm}}</div>
                                        </li>
                                        <li class="content-table-cell-list">
                                            <div class="">
                                                {{room.firAmStr}}
                                            </div>
                                            <div class="">
                                                {{room.zfirAmStr}}
                                            </div>
                                        </li>
                                        <li class="content-table-cell-list">
                                            <div class="">
                                                {{room.secAmStr}}
                                            </div>
                                            <div class="">
                                                {{room.zsecAmStr}}
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    methods: {},
});
